import axios from '@src/public/utils/request';

// 热榜接口
export const getHotRank = () => {
    return axios.get('/timeline/front/api/hot/timeline');
};

// 最近更新接口
export const getUpdates = (page, size) => {
    return axios.get('/timeline/front/api/nodes/updates', {
        params: { page, size },
    });
};
